import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Publish new version of a component
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestPublishComponent = packet => {
  return {
    type: 'REQUEST_PUBLISH_COMPONENT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receivePublishComponentSuccess = data => ({
  type: 'RECEIVE_PUBLISH_COMPONENT_SUCCESS',
  data
})

export const receivePublishComponentFail = data => ({
  type: 'RECEIVE_PUBLISH_COMPONENT_FAIL',
  data
})

export const tryToPublishComponent = packet => (dispatch, getState) => {

  dispatch(requestPublishComponent(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/publish/' + packet.id, {
      method: 'post',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receivePublishComponentSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receivePublishComponentFail({errors:e, lastSubmit: packet}));
    })
}
